import { render } from "./UserTicketTecnici.vue?vue&type=template&id=6010dcc6&scoped=true"
import script from "./UserTicketTecnici.vue?vue&type=script&lang=js"
export * from "./UserTicketTecnici.vue?vue&type=script&lang=js"

import "./UserTicketTecnici.vue?vue&type=style&index=0&id=6010dcc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6010dcc6"]])

export default __exports__